import { BUSINESS_SOLUTION_ORGANIZATION_ID } from '@app/access/constants/organizations';
import { config } from '@app/config';
import { useUserPrint } from '@app/hooks/useUserPrint';

import { getProxyEnvironment, getProxyServiceOrigin } from '../utils/frame';

export const useProxyAccess = () => {
  const { params } = useUserPrint();
  const environment = getProxyEnvironment(config.mode);
  const origin = getProxyServiceOrigin(config.proxyServiceOrigin, config.mode);
  const allowed = params.Database === BUSINESS_SOLUTION_ORGANIZATION_ID;

  return {
    allowed,
    environment,
    origin,
    visible: allowed && environment !== null && origin !== null,
  };
};
